// The takeoff ribbon's tabs (used when the window is too small for every tile at once — see viewportTier.js). Each of the
// ribbon's tile groups belongs to exactly one tab; the quick strip on the always-visible bar carries the few controls used
// constantly (tools, undo / redo, zoom, the drawing). A per-viewer VIEW setting: the last tab is remembered.

export const RIBBON_TABS = Object.freeze([
  { key: "drawings", label: "Drawings" },
  { key: "draw", label: "Draw" },
  { key: "view", label: "View" },
  { key: "review", label: "Review" },
]);

export const RIBBON_TAB_KEY = "cs.takeoff.ribbonTab";
const KEYS = RIBBON_TABS.map(t => t.key);

export const normalizeRibbonTab = (k) => (KEYS.includes(k) ? k : "draw");

export const readRibbonTab = (storage = typeof localStorage !== "undefined" ? localStorage : null) => {
  try { return normalizeRibbonTab(storage?.getItem(RIBBON_TAB_KEY)); } catch { return "draw"; }
};
export const writeRibbonTab = (key, storage = typeof localStorage !== "undefined" ? localStorage : null) => {
  try { storage?.setItem(RIBBON_TAB_KEY, normalizeRibbonTab(key)); } catch { /* a view preference only */ }
};

/** Does a tile group show? Everything shows when the ribbon is not tabbed; otherwise only the active tab's groups. */
export const groupVisible = ({ tabbed, active, tab }) => !tabbed || active === tab;
